module.exports = __webpack_public_path__ + "static/media/barcodeImage_pdf417.69d88f6b.svg";